/* Little Sonny theme — forms that post to the existing Little Sonny backend */
(function () {
  'use strict';

  var LS = window.LittleSonny || {};
  var BASE = LS.functionsUrl;

  function invoke(name, payload) {
    return fetch(BASE + '/' + name, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: LS.anonKey,
        Authorization: 'Bearer ' + LS.anonKey
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response
        .json()
        .catch(function () { return {}; })
        .then(function (data) {
          if (!response.ok) throw new Error(data.error || 'Something went wrong. Please try again.');
          return data;
        });
    });
  }

  function setLoading(form, loading, loadingLabel) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;
    button.disabled = loading;
    var label = button.querySelector('[data-submit-label]');
    if (!label) return;
    if (loading) {
      label.dataset.original = label.textContent;
      label.textContent = loadingLabel || 'Sending…';
    } else if (label.dataset.original) {
      label.textContent = label.dataset.original;
    }
  }

  function showSuccess(form, message) {
    var target = form.querySelector('[data-form-success]');
    if (target) {
      target.textContent = message;
      target.classList.remove('hidden');
    }
    if (LS.toast) LS.toast(message);
  }

  /* ------------------------------------------------------- newsletter */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-newsletter-form]');
    if (!form) return;
    event.preventDefault();
    var email = form.querySelector('input[name="email"]').value.trim();
    if (!email) return;
    setLoading(form, true, 'Subscribing…');
    invoke('newsletter-subscribe', { email: email, source: form.dataset.source || 'theme' })
      .then(function () {
        form.reset();
        showSuccess(form, "Thanks for subscribing — you're on the list.");
      })
      .catch(function (error) {
        if (LS.toast) LS.toast('Could not subscribe', error.message);
      })
      .then(function () { setLoading(form, false); });
  });

  /* ---------------------------------------------------------- contact */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-contact-form]');
    if (!form) return;
    event.preventDefault();
    var data = new FormData(form);
    setLoading(form, true);
    invoke('submit-contact-message', {
      name: data.get('name'),
      email: data.get('email'),
      orderNumber: data.get('orderNumber') || '',
      message: data.get('message')
    })
      .then(function () {
        form.reset();
        showSuccess(form, "Thanks — we've got your message and will reply by email.");
      })
      .catch(function (error) {
        if (LS.toast) LS.toast('Could not send your message', error.message);
      })
      .then(function () { setLoading(form, false); });
  });

  /* --------------------------------------------------- Australia returns */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-aus-return-form]');
    if (!form) return;
    event.preventDefault();
    var data = new FormData(form);
    setLoading(form, true);
    invoke('submit-aus-return', {
      name: data.get('name'),
      email: data.get('email'),
      orderNumber: data.get('orderNumber'),
      reason: data.get('reason')
    })
      .then(function () {
        form.reset();
        showSuccess(form, "Thanks — your return request is with us and we'll be in touch by email.");
      })
      .catch(function (error) {
        if (LS.toast) LS.toast('Could not send your request', error.message);
      })
      .then(function () { setLoading(form, false); });
  });
})();

/* ------------------------------------------------- creator applications */
(function () {
  'use strict';
  var LS = window.LittleSonny || {};
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-creator-form]');
    if (!form) return;
    event.preventDefault();
    var data = new FormData(form);
    var country = String(data.get('dial') || 'GB|+44').split('|');
    var phone = String(data.get('phone') || '').replace(/[\s-]/g, '');
    var button = form.querySelector('button[type="submit"]');
    var label = form.querySelector('[data-submit-label]');
    if (button) button.disabled = true;
    if (label) label.textContent = 'Sending…';

    fetch(LS.functionsUrl.replace('/functions/v1', '') + '/rest/v1/creator_applications', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: LS.anonKey,
        Authorization: 'Bearer ' + LS.anonKey,
        Prefer: 'return=minimal'
      },
      body: JSON.stringify({
        first_name: data.get('firstName'),
        email: data.get('email'),
        country_code: phone ? country[0] : null,
        dial_code: phone ? country[1] : null,
        phone: phone || null,
        instagram: data.get('instagram') || null,
        tiktok: data.get('tiktok') || null
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('failed');
        form.reset();
        var success = form.querySelector('[data-form-success]');
        if (success) {
          success.textContent = "Application received — we'll be in touch soon.";
          success.classList.remove('hidden');
        }
        if (LS.toast) LS.toast('Application received', "We'll be in touch soon.");
      })
      .catch(function () {
        if (LS.toast) LS.toast('Something went wrong', 'Please try again in a moment.');
      })
      .then(function () {
        if (button) button.disabled = false;
        if (label) label.textContent = 'Apply';
      });
  });
})();
